import { RouterProvider } from "react-router-dom";
import { QueryProvider } from "@/providers/query-provider";
import { useEventStream } from "@/hooks/use-event-stream";
import { router } from "@/router";

// Mounted inside QueryProvider so useQueryClient() resolves. Renders nothing
// — purely a side-effect bridge that opens the SSE stream and invalidates
// cached queries when the bot emits events.
function RealtimeBridge() {
  useEventStream();
  return null;
}

export default function App() {
  return (
    <QueryProvider>
      <RealtimeBridge />
      <RouterProvider router={router} />
    </QueryProvider>
  );
}
